import React, { useEffect } from "react";
import { ConfirmDialog, FormValidationSummary, Stack, ValidationResult } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../common/api/master-api/file-records/useFileRecordApi";
import { AssetOperationSection } from "../../../../common/asset-operations/AssetOperationSection";
import { OnPremAssetOperationList } from "../../../../common/asset-operations/OnPremAssetOperationList";

interface FileRecordQcDoneDialogProps {
    itemId: string;
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
}

export const FileRecordQcDoneDialog: React.VFC<FileRecordQcDoneDialogProps> = ({
    itemId,
    isOpen,
    onClose,
    onSubmit
}: FileRecordQcDoneDialogProps) => {
    const [isValidating, setIsValidating] = React.useState(false);
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [validationResult, setValidationResult] = React.useState<ValidationResult>();

    const { changeFileRecordToQcDone, validateFileRecordToQcDone } = useFileRecordApi();

    useEffect(() => {
        if (isOpen) {
            handleValidation();
        }
    }, [isOpen]);

    const handleConfirmation = async () => {
        await changeFileRecordToQcDone({ fileRecordId: itemId });

        onSubmit();

        setIsSubmitted(true);
    };

    const handleValidation = () => {
        setIsValidating(true);

        validateFileRecordToQcDone({ fileRecordId: itemId })
            .then((response) => {
                setValidationResult(response);
            })
            .finally(() => {
                setIsValidating(false);
            });
    };

    const isDisabled = !validationResult?.isValid || isValidating || isSubmitted;
    return (
        <ConfirmDialog
            width={1200}
            title="Change status to Qc Done"
            text="Are you sure you want to make qc done on this file record?"
            hidden={!isOpen}
            confirm={{
                onClick: handleConfirmation,
                disabled: isDisabled
            }}
            cancel={{ onClick: onClose, buttonText: isSubmitted ? "Close" : "Cancel" }}
        >
            {!validationResult?.isValid ? (
                <Stack tokens={{ padding: "10px 0" }}>
                    <FormValidationSummary
                        styles={{ root: { whiteSpace: "pre-line" } }}
                        isValidating={isValidating}
                        validationResult={validationResult}
                    />
                </Stack>
            ) : (
                <AssetOperationSection isQcDoneConfirmed={isSubmitted}>
                    <OnPremAssetOperationList fileRecordId={itemId} />
                </AssetOperationSection>
            )}
        </ConfirmDialog>
    );
};
